site.stickyHead = {
	init: function() {
		window.addEventListener('scroll', function(e){
			var distanceY = window.pageYOffset || document.documentElement.scrollTop,
				shrinkOn = 300;
			if (window.outerWidth < 991 && $('body').hasClass('frontpage')) {
				if (distanceY > shrinkOn) {
					$('body').addClass('stickyHead');
				} else {
					$('body').removeClass('stickyHead');
				}
			}
		});
	}
};

site.inits.push('site.stickyHead.init()');
